<template>
  <div class="product content-box">
    <div>
      <el-button type="primary" @click="addProduct">发布商品</el-button>
    </div>
    <!-- 数据筛选 -->
    <Header
      :classifyList="classifyList"
      @input="changeValue"
      :keyword="keyword"
      :productCategoryId="productCategoryId"
      :maxPrice="maxPrice"
      :minPrice="minPrice"
      :maxSale="maxSale"
      :minSale="minSale"
      @download="handleDownload"
      @search="handleSearch"
    />

    <!-- 数据列表 -->
    <Table
      :keyword="keyword"
      :productCategoryId="productCategoryId"
      :maxPrice="maxPrice"
      :minPrice="minPrice"
      :maxSale="maxSale"
      :minSale="minSale"
      ref="table"
      :dictionary="dictionary"
    />
  </div>
</template>

<script>
import { Vue, Component, Watch, Mixins } from "vue-property-decorator";
import {
  productList,
  checktProductClass,
  createProduct,
  updateProduct,
  updateInfo,
  productCategoryAll,
} from "@/api/productList";
import { CreateProduct } from "@/types/api/productList";
import { freightSelectByObj, freightDel } from "@/api/freight";
import quillEditorImgUpload from "@/utils/quillEditorImgUpload";
import print from "@/utils/print";
import { allParentList, checkDict } from "@/api/system";

// 组价
import Table from "./components/Table";
import Header from "./components/Header";
// 工具
import copy from "@/utils/deepCopy";
import debounce from "@/utils/debounce";
import inputPrice from "@/utils/inputPrice";

@Component({
  components: {
    Header,
    Table,
  },
})
export default class Order extends Vue {
  classifyList = []; // 分类列表
  keyword = ""; // 搜索关键词
  productCategoryId = ""; // 商品分类id
  dictionary = []; // 数据字典
  maxPrice = "";
  minPrice = "";
  maxSale = "";
  minSale = "";

  mounted() {
    this.getClassify();
    this.getAllDictionary();
  }

  /**
   * 监听
   */
  @Watch("productCategoryId")
  @Watch("keyword")
  @Watch("maxPrice")
  @Watch("minPrice")
  @Watch("maxSale")
  @Watch("minSale")
  searchValue() {
    debounce(() => this.handleSearch());
  }

  // 获取分类
  getClassify() {
    productCategoryAll().then((res) => {
      this.classifyList = res.data;
    });
  }

  // 获取数据字典
  getAllDictionary() {
    checkDict({
      parentId: 2,
    }).then((res) => {
      this.dictionary = res.data.list;
    });
  }

  // 头部输入
  changeValue(val, type) {
    this[type] = val;
  }

  // 搜索
  handleSearch() {
    this.$refs.table.getData();
  }

  handleDownload() {
    this.$refs.table.importExcel();
  }

  addProduct() {
    this.$router.push({
      path: "/addProduct",
    });
  }
}
</script>



<style lang="scss" scoped src="./style.scss"></style>